<template>
  <div class="app-version-component q-pl-sm">
    <span>{{ env }}{{ version }}</span>
  </div>
</template>

<script>
  import { APP_VERSION, ENVIRONMENT } from "@core/constants";

  export default {
    computed: {
      env() {
        if (ENVIRONMENT !== "production") {
          return `${ENVIRONMENT} - `;
        }
        return "";
      },
      version() {
        return `v${APP_VERSION}`;
      },
    },
  };
</script>

<style lang="scss">
  .app-version-component {
    font-size: 0.85em;
    color: $lightgrey;
  }
</style>
